module.exports = __webpack_public_path__ + "img/page.d605a868.png";